module.exports = __webpack_public_path__ + "img/pt-br.7822540e.png";